const baseUrl = process.env.REACT_APP_baseUrl;
export { baseUrl};